import React from 'react';
import { useIntl } from 'react-intl';
import { Dropdown } from 'semantic-ui-react';

const listItem = (intl, permission, value, entity) => ({
  key: `member_permissions_dropdown_item_${entity}_${permission.toLowerCase()}`,
  text: intl.formatMessage({ id: `user.permission.${entity}.${permission.toLowerCase()}` }),
  value: permission,
  active: permission === value,
  description: intl.formatMessage({ id: `user.permission.${entity}.${permission.toLowerCase()}.description` }),
});

const listItems = (intl, permissionGroups, value, entity) => {
  const items = Object.keys(permissionGroups).map((permission) => (listItem(intl, permission, value, entity)));
  if (value === 'custom') {
    items.push(listItem(intl, 'custom', value, entity));
  }

  return items;
};

const MemberPermissionsDropdown = ({
  permissionGroups,
  permission,
  disabled,
  entity,
  onChange,
}) => {
  const intl = useIntl();
  return (
    <Dropdown
      className="aridhia-member-permission-dropdown max-content"
      id="member_permissions"
      options={listItems(intl, permissionGroups, permission, entity)}
      disabled={disabled}
      value={permission}
      fluid
      selection
      onChange={(e, { value }) => { onChange(value); }}
    />
  );
};

export default MemberPermissionsDropdown;
